import React, { useRef } from "react"
import { useDispatch } from "react-redux"
import Tab from "@mui/material/Tab"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import theme from "lib/material-ui/theme"
import { MINIMIZED_PROFILE_BANNER_HEIGHT } from "constants/index"
import { useAppSelector } from "appRedux/hooks"
import { updateSelectedTabIndex } from "appRedux/slices/profileTabsSlice"
import { StyledTabs } from "components/atoms/Tabs/StyledTabs"
import TabPanel from "components/atoms/Tabs/TabPanel"

type tabDataType = {
  label: string | React.ReactNode;
  disabled: boolean;
  content: React.ReactNode;
  onChange?: () => void;
}

type TabsPanelProps = {
  data: tabDataType[];
  selectedTabIndex: number;
  isMinimized: boolean;
  isFixed: boolean;
}

export default function TabsPanel(props: TabsPanelProps) {
  const { data = [], selectedTabIndex, isMinimized, isFixed } = props

  const viewedUser = useAppSelector((state) => state.viewedUser)

  const tabsRef = useRef<HTMLDivElement>(null)

  const dispatch = useDispatch()

  function handleTabChange(event: React.SyntheticEvent, newValue: ProfileSelectedTabIndex) {
    data[newValue]?.onChange?.()
    if (!viewedUser?.profile) return
    dispatch(updateSelectedTabIndex({ handle: viewedUser?.profile?.handle, index: newValue }))
  }

  return (
    <Stack flexGrow={1}>
      <Box
        ref={tabsRef}
        sx={{
          position: isFixed ? "fixed" : "relative",
          top: isFixed ? (isMinimized ? `${MINIMIZED_PROFILE_BANNER_HEIGHT}px` : "300px") : "initial",
          width: "100%",
          maxWidth: "var(--max-container-width)",
          zIndex: isFixed ? 2 : 0,
          backgroundColor: theme.palette.gray[2],
        }}
      >
        <StyledTabs value={selectedTabIndex} onChange={handleTabChange}>
          {data.map((tabData, index) => (
            <Tab
              key={index}
              label={tabData?.label}
              disabled={tabData?.disabled}
              id={`simple-tab-${index}`}
              aria-controls={`tabpanel-${index}`}
            />
          ))}
        </StyledTabs>
      </Box>

      {data.map((tabData, index) => (
        <TabPanel
          key={index}
          index={index}
          value={selectedTabIndex}
        >
          {tabData.content}
        </TabPanel>
      ))}
    </Stack>
  )
}
